import { 
  Link, MapPin, Mail, Phone, Wifi, FileText, Calendar,
  MessageCircle, Instagram, Facebook, Twitter, Linkedin, Youtube, Music, Video,
  CreditCard, Bitcoin, Smartphone, Apple, ShoppingCart, Star, QrCode, Menu,
  Heart, Sparkles, Diamond, Circle, Square, Hexagon, Triangle, Octagon,
  Shield, Laptop, Watch, Camera, ShoppingBag, Clipboard, MessageSquare, Flag
} from 'lucide-react';

export const dotsStyles = [
  { id: 'square', name: 'Square', icon: Square },
  { id: 'rounded', name: 'Rounded', icon: Square },
  { id: 'dots', name: 'Dots', icon: Circle },
  { id: 'extra-rounded', name: 'Extra Rounded', icon: Circle },
  { id: 'classy', name: 'Classy', icon: Diamond },
  { id: 'classy-rounded', name: 'Classy Rounded', icon: Diamond },
] as const;

export const cornersSquareStyles = [
  { id: 'square', name: 'Square', icon: Square },
  { id: 'dot', name: 'Dot', icon: Circle },
  { id: 'extra-rounded', name: 'Extra Rounded', icon: Circle },
  { id: 'rounded', name: 'Rounded', icon: Square },
  { id: 'dots', name: 'Dots', icon: Circle },
  { id: 'classy', name: 'Classy', icon: Diamond },
  { id: 'classy-rounded', name: 'Classy Rounded', icon: Diamond },
] as const;

export const cornersDotStyles = [
  { id: 'square', name: 'Square', icon: Square },
  { id: 'dot', name: 'Dot', icon: Circle },
  { id: 'rounded', name: 'Rounded', icon: Square },
  { id: 'dots', name: 'Dots', icon: Circle },
  { id: 'extra-rounded', name: 'Extra Rounded', icon: Circle },
  { id: 'classy', name: 'Classy', icon: Diamond },
  { id: 'classy-rounded', name: 'Classy Rounded', icon: Diamond },
] as const;

export const frameStyles = [
  { id: 'none', name: 'No Frame' },
  { id: 'simple', name: 'Simple Border' },
  { id: 'rounded', name: 'Rounded Border' },
  { id: 'circle', name: 'Circle Frame' },
  { id: 'scan-me-top', name: 'Scan Me (Top)' },
  { id: 'scan-me-bottom', name: 'Scan Me (Bottom)' },
  { id: 'phone', name: 'Phone Icon' },
  { id: 'instagram', name: 'Instagram Style' },
  { id: 'tag', name: 'Tag with Text' },
  { id: 'double', name: 'Double Border' },
  { id: 'decorative', name: 'Decorative Corners' },
  { id: 'badge', name: 'Badge Style' },
  { id: 'ticket', name: 'Ticket Stub' },
  { id: 'gradient', name: 'Gradient Border' },
  { id: 'neon', name: 'Neon Glow' },
  { id: 'clipboard', name: 'Clipboard' },
  { id: 'laptop', name: 'Laptop' },
  { id: 'watch', name: 'Watch' },
  { id: 'camera', name: 'Camera' },
  { id: 'bag', name: 'Bag' },
  { id: 'speech-bubble', name: 'Speech Bubble' },
  { id: 'banner', name: 'Banner' },
] as const;

export const prefilledLogos = [
  // General
  { id: 'link', name: 'Link', icon: Link, category: 'general' },
  { id: 'location', name: 'Location', icon: MapPin, category: 'general' },
  { id: 'email', name: 'Email', icon: Mail, category: 'general' },
  { id: 'phone', name: 'Phone', icon: Phone, category: 'general' },
  { id: 'wifi', name: 'WiFi', icon: Wifi, category: 'general' },
  { id: 'pdf', name: 'PDF', icon: FileText, category: 'general' },
  { id: 'calendar', name: 'Calendar', icon: Calendar, category: 'general' },
  { id: 'qrcode', name: 'QR Code', icon: QrCode, category: 'general' },
  
  // Social
  { id: 'whatsapp', name: 'WhatsApp', icon: MessageCircle, category: 'social' },
  { id: 'instagram', name: 'Instagram', icon: Instagram, category: 'social' },
  { id: 'facebook', name: 'Facebook', icon: Facebook, category: 'social' },
  { id: 'twitter', name: 'Twitter/X', icon: Twitter, category: 'social' },
  { id: 'linkedin', name: 'LinkedIn', icon: Linkedin, category: 'social' },
  { id: 'youtube', name: 'YouTube', icon: Youtube, category: 'social' },
  { id: 'spotify', name: 'Spotify', icon: Music, category: 'social' },
  { id: 'tiktok', name: 'TikTok', icon: Video, category: 'social' },
  
  // Payment
  { id: 'paypal', name: 'PayPal', icon: CreditCard, category: 'payment' },
  { id: 'bitcoin', name: 'Bitcoin', icon: Bitcoin, category: 'payment' },
  { id: 'card', name: 'Credit Card', icon: CreditCard, category: 'payment' },
  { id: 'applepay', name: 'Apple Pay', icon: Apple, category: 'payment' },
  { id: 'googlepay', name: 'Google Pay', icon: Smartphone, category: 'payment' },
  
  // Business/Retail
  { id: 'menu', name: 'Menu', icon: Menu, category: 'business' },
  { id: 'review', name: 'Review', icon: Star, category: 'business' },
  { id: 'shopping', name: 'Shopping', icon: ShoppingCart, category: 'business' },
  { id: 'bag', name: 'Bag', icon: ShoppingBag, category: 'business' },
  { id: 'tag', name: 'Price Tag', icon: Flag, category: 'business' },
  { id: 'laptop', name: 'Tech', icon: Laptop, category: 'business' },
  { id: 'camera', name: 'Photography', icon: Camera, category: 'business' },
  { id: 'watch', name: 'Luxury', icon: Watch, category: 'business' },

  // Symbols
  { id: 'heart', name: 'Heart', icon: Heart, category: 'symbols' },
  { id: 'sparkles', name: 'Sparkles', icon: Sparkles, category: 'symbols' },
  { id: 'shield', name: 'Secure', icon: Shield, category: 'symbols' },
  { id: 'diamond', name: 'Premium', icon: Diamond, category: 'symbols' },
  { id: 'star', name: 'Star', icon: Star, category: 'symbols' },
] as const;

export const qrTypeToLogo: Record<string, string> = {
  url: 'link',
  vcard: 'phone',
  wifi: 'wifi',
  email: 'email',
  sms: 'phone',
  whatsapp: 'whatsapp',
  phone: 'phone',
  location: 'location',
  text: 'qrcode',
  calendar: 'calendar',
  paypal: 'paypal',
  bitcoin: 'bitcoin',
  appstore: 'applepay',
  pdf: 'pdf',
  instagram: 'instagram',
  twitter: 'twitter',
  linkedin: 'linkedin',
};

export const errorCorrectionLevels = [
  { id: 'L', name: 'Low (7%)', description: 'Smallest QR code, less damage resistance' },
  { id: 'M', name: 'Medium (15%)', description: 'Balanced size and damage resistance' },
  { id: 'Q', name: 'Quartile (25%)', description: 'Good damage resistance, larger code' },
  { id: 'H', name: 'High (30%)', description: 'Best for logos, highest damage resistance' },
] as const;

export const resolutionOptions = [
  { value: 1000, label: 'Standard (1000px)' },
  { value: 2000, label: 'High (2000px)' },
  { value: 4000, label: 'Print (4000px)' },
] as const;

// Design presets for batch creation
export const designPresets = [
  { id: 'classic', name: 'Classic', dotsColor: '#000000', backgroundColor: '#ffffff', dotsType: 'square' as const },
  { id: 'modern', name: 'Modern', dotsColor: '#1a1a2e', backgroundColor: '#ffffff', dotsType: 'rounded' as const },
  { id: 'elegant', name: 'Elegant', dotsColor: '#2d3436', backgroundColor: '#dfe6e9', dotsType: 'extra-rounded' as const },
  { id: 'ocean', name: 'Ocean', dotsColor: '#0984e3', backgroundColor: '#ffffff', dotsType: 'dots' as const },
  { id: 'forest', name: 'Forest', dotsColor: '#00b894', backgroundColor: '#ffffff', dotsType: 'rounded' as const },
  { id: 'sunset', name: 'Sunset', dotsColor: '#e17055', backgroundColor: '#ffeaa7', dotsType: 'classy-rounded' as const },
  { id: 'purple', name: 'Purple', dotsColor: '#6c5ce7', backgroundColor: '#ffffff', dotsType: 'rounded' as const },
  { id: 'dark', name: 'Dark', dotsColor: '#ffffff', backgroundColor: '#2d3436', dotsType: 'dots' as const },
] as const;
